var map = {
	"./AddressPolicy.js": 4354,
	"./ComponentPolicy.js": 3791,
	"./CustomerPolicy.js": 386,
	"./DisabilityPolicy.js": 4567,
	"./ElementPolicy.js": 6622,
	"./FloorPolicy.js": 2790,
	"./FoundationPolicy.js": 302,
	"./GroupPolicy.js": 7410,
	"./IssuePolicy.js": 8956,
	"./ProjectFoundationPolicy.js": 2230,
	"./ProjectPolicy.js": 2654,
	"./RoomPolicy.js": 7545,
	"./ServicePolicy.js": 9963,
	"./StaffMemberPolicy.js": 1434,
	"./UserPolicy.js": 3201,
	"./WallPolicy.js": 1583
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1565;